(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const connection = navigator.connection;
  const saveData = !!connection?.saveData || /(^|-)2g$/.test(connection?.effectiveType || '');
  function init(scope = document) {
    if (!reduced.matches && !matchMedia('(max-width: 749px)').matches && 'IntersectionObserver' in window) {
      document.documentElement.classList.add('eclat-ready');
      const reveal = new IntersectionObserver(entries => entries.forEach(entry => {
        if (entry.isIntersecting) { entry.target.classList.remove('eclat-pending'); reveal.unobserve(entry.target); }
      }), { threshold: .08 });
      scope.querySelectorAll('[data-eclat-reveal]:not([data-eclat-init])').forEach(el => {
        el.dataset.eclatInit = 'true'; el.classList.add('eclat-pending'); reveal.observe(el);
      });
    }
    scope.querySelectorAll('[data-eclat-film]:not([data-eclat-init])').forEach(video => {
      video.dataset.eclatInit = 'true';
      const button = video.closest('.eclat-hero').querySelector('[data-video-toggle]');
      let userPaused = false;
      const update = () => { button.textContent = video.paused ? 'Lire le film' : 'Mettre en pause'; button.setAttribute('aria-label', video.paused ? 'Lire la vidéo d’ambiance' : 'Mettre en pause la vidéo d’ambiance'); };
      const play = () => { if (!reduced.matches && !saveData && !userPaused && !document.hidden) video.play().catch(update); };
      video.addEventListener('play', update); video.addEventListener('pause', update);
      button.hidden = false;
      button.addEventListener('click', () => { if (video.paused) { userPaused = false; video.play().catch(update); } else { userPaused = true; video.pause(); } });
      document.addEventListener('visibilitychange', () => { if (document.hidden) video.pause(); });
      reduced.addEventListener('change', () => { if (reduced.matches) video.pause(); else play(); });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(entries => entries.forEach(e => { if (e.isIntersecting) play(); else video.pause(); }), {threshold:.1}).observe(video);
      } else play();
      video.addEventListener('error', () => { button.hidden = true; video.hidden = true; });
      update();
    });
  }
  init(); document.addEventListener('shopify:section:load', event => init(event.target));
})();
(() => {
  if (!document.querySelector('main[data-template="product"]')) return;
  const form = document.querySelector('main product-form');
  if (!form || !('IntersectionObserver' in window)) return;
  const bar = document.createElement('div'); bar.className = 'eclat-mobile-buy';
  const link = document.createElement('button'); link.type = 'button'; link.className = 'button'; link.textContent = 'Choisir mon format';
  link.addEventListener('click', () => {
    const target = document.querySelector('main variant-selects') || form;
    target.scrollIntoView({block:'center',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
    const control = target.querySelector('input:checked, select, button[type="submit"]');
    if(control) control.focus({preventScroll:true});
  });
  bar.append(link); document.body.append(bar);
  new IntersectionObserver(([entry]) => { bar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0); }).observe(form);
})();
